import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { showAccountsAction } from 'store/modules/content/actions';
import buildPrice from 'helpers/buildPrice';
import AlertMessage from 'components/AlertMessage';
import classnames from 'classnames';

import UpdatePaymentDetails from 'components/UpdatePaymentDetails';
import UpdateBillingPeriod from 'components/UpdateBillingPeriod';
import { showUserAction } from 'store/modules/profileDetails/actions';
import {
  updateBillingPeriodAction,
  updatePaymentAction,
  disableRenewAction,
  enableRenewAction,
} from 'store/modules/content/actions';

class CurrentPlan extends Component {
  state = {
    isOpen: false,
    isOpenPeriod: false,
    isOpenCancel: false,
    createSubscriptionSpinner: false,
    enableAutoRenewSpinner: false,
    disableAutoRenewSpinner: false,
  };

  componentDidMount() {
    const {
      showAccountAction,
      showUserAction,
      match,
      showAccountsAction,
    } = this.props;
    const id = match.params.id;
    showUserAction(id);
    if (this.props.accounts.length === 0) {
      showAccountsAction();
    }
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  togglePeriod = () => {
    this.setState({
      isOpenPeriod: !this.state.isOpenPeriod,
    });
  };

  toggleCancel = () => {
    this.setState({ isOpenCancel: !this.state.isOpenCancel });
  };

  updatePayment = async (values, setSubmitting, setErrors, resetForm) => {
    const { updatePaymentAction } = this.props;
    const body = {
      card: {
        number: values.ccnumber.toString().replace(/ /g, ''),
        exp_month: values.exp_month.toString(),
        exp_year: (2000 + parseInt(values.exp_year)).toString(),
        cvc: values.cvv2.toString().replace(/ /g, ''),
        name: values.first_name + ' ' + values.last_name,
        address_country: values.country,
        address_line1: values.address,
        address_zip: values.zip,
      },
    };
    const response = await updatePaymentAction(body, setSubmitting, setErrors);
    if (response.status === 200) {
      this.setState({ isOpen: false });
      this.setState({ showAlertSuccess: true });
      this.setState({
        alertTextSuccess: 'Payment details successfully updated!',
      });
      setTimeout(() => {
        this.setState({ showAlertSuccess: false });
      }, 4000);
      resetForm();
    } else {
      this.setState({ showAlertError: true });
      this.setState({
        alertTextError: response.error.message,
      });
      setTimeout(() => {
        this.setState({ showAlertError: false });
      }, 5000);
    }
  };

  updateBilling = async (values, setSubmitting, setErrors) => {
    const { updateBillingPeriodAction } = this.props;
    const { subscription_plan, next_subscription_plan } = this.props.details;
    let plan;
    if (!next_subscription_plan) {
      plan = subscription_plan === 'monthly' ? 'annually' : 'monthly';
    } else {
      plan = next_subscription_plan === 'monthly' ? 'annually' : 'monthly';
    }
    const body = {
      plan: plan,
    };
    const response = await updateBillingPeriodAction(
      body,
      setSubmitting,
      setErrors,
    );
    if (response.status === 200) {
      this.setState({ isOpenPeriod: false });
      this.setState({ showAlertSuccess: true });
      this.setState({
        alertTextSuccess: 'Billing period successfully updated!',
      });
      setTimeout(() => {
        this.setState({ showAlertSuccess: false });
      }, 4000);
    } else {
      this.setState({ showAlertError: true });
      this.setState({
        alertTextError: response.data,
      });
      setTimeout(() => {
        this.setState({ showAlertError: false });
      }, 4000);
    }
  };

  handleCreateSubscription = async () => {
    const { createSubscriptionAction } = this.props;
    this.setState({
      createSubscriptionSpinner: true,
    });
    const response = await createSubscriptionAction();
    this.setState({
      createSubscriptionSpinner: false,
    });
    if (response.status !== 200) {
      console.error('test  ', response.textError.message.charge);
    }
  };

  handleAutoRenew = async () => {
    if (this.props.details.subscription_auto_renew) {
      const { disableRenewAction } = this.props;
      this.setState({ disableAutoRenewSpinner: true });
      await disableRenewAction();
      this.setState({ disableAutoRenewSpinner: false });
    } else {
      const { enableRenewAction } = this.props;
      this.setState({ enableAutoRenewSpinner: true });
      await enableRenewAction();
      this.setState({ enableAutoRenewSpinner: false });
    }
    this.toggleCancel();
  };

  renderCancelButton = () => {
    const { subscribed, subscription_auto_renew } = this.props.details;
    const {
      disableAutoRenewSpinner,
      enableAutoRenewSpinner,
      isOpenCancel,
      showAlertError,
      showAlertSuccess,
      alertTextError,
      alertTextSuccess,
    } = this.state;
    const { isSubmitting, details } = this.props;
    return (
      <Fragment>
        {showAlertSuccess && <AlertMessage text={alertTextSuccess} />}
        {showAlertError && (
          <AlertMessage
            classAlert={classnames({ error: true })}
            text={alertTextError}
          />
        )}
        {subscribed && subscription_auto_renew && (
          <button
            className="btn btn-grey"
            onClick={this.toggleCancel}
            disabled={disableAutoRenewSpinner || details.trial}>
            {disableAutoRenewSpinner ? 'Loading' : 'Cancel plan'}
          </button>
        )}
        {subscribed && !subscription_auto_renew && (
          <button
            className="btn btn-grey"
            onClick={this.toggleCancel}
            disabled={enableAutoRenewSpinner}>
            {enableAutoRenewSpinner ? 'Loading' : 'Enable plan'}
          </button>
        )}
        <Modal isOpen={isOpenCancel} className={this.props.className}>
          <ModalHeader toggle={this.toggleCancel}>
            <div className="h2-title">Auto renew</div>
          </ModalHeader>
          <div className="separator-line" />
          <ModalBody>
            Are you sure you want to{' '}
            {subscription_auto_renew ? 'cancel' : 'enable'} plan?
          </ModalBody>
          <ModalFooter>
            <Button
              color="blue"
              className="m-r-15"
              onClick={this.handleAutoRenew}
              disabled={disableAutoRenewSpinner}>
              {isSubmitting
                ? 'Loading'
                : subscription_auto_renew
                ? 'Cancel'
                : 'Enable'}
            </Button>{' '}
            <Button
              color="blue"
              className="outline"
              onClick={this.toggleCancel}>
              Exit
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  };

  render() {
    const {
      subscription_auto_renew,
      subscribed,
      email,
      formatted_subscription_end_datetime,
      payment_method_added,
      subscription_plan,
      next_subscription_plan,
    } = this.props.details;
    const { accounts, details } = this.props;
    let plan;
    if (next_subscription_plan === 'annually') {
      plan = 'per year';
    } else if (next_subscription_plan === 'monthly') {
      plan = 'per month';
    } else {
      if (subscription_plan === 'annually') {
        plan = 'per year';
      } else {
        plan = 'per month';
      }
    }
    const cost =
      buildPrice(accounts.length, next_subscription_plan) +
      accounts.filter(e => e.premium_shortcode).length *
        (next_subscription_plan === 'monthly' ? 3 : 30);
    return (
      <Fragment>
        <h2 className="h2-title">Current plan</h2>
        <div className="separator-line" />
        <div className="cr-plan m-b-50">
          {details.trial ? (
            <span>This section is unavailable for complimentary accounts</span>
          ) : (
            <div>
              <div className="cr-plan-top__row">
                <span className="appname std-text bold">
                  InstaLinks
                  <span className="type">Pro</span>
                </span>
                {this.renderCancelButton()}
              </div>
              <div className="cr-plan-bottom__row">
                <p className="renew-date std-text">
                  {subscription_auto_renew
                    ? 'Your plan will renew on'
                    : 'Your plan will end on'}{' '}
                  {formatted_subscription_end_datetime && (
                    <span className="std-text">
                      {formatted_subscription_end_datetime}
                    </span>
                  )}
                </p>
                {accounts.length && (
                  <p className="cost std-text">
                    You have {accounts.length} domains.
                  </p>
                )}
                <p className="cost std-text">
                  You will be charged next time ${cost}.
                </p>
                <UpdateBillingPeriod
                  isOpen={this.state.isOpenPeriod}
                  toggle={this.togglePeriod}
                  handleSubmit={this.updateBilling}
                  plan={subscription_plan}
                  nextPlan={next_subscription_plan}
                />
                <UpdatePaymentDetails
                  isOpen={this.state.isOpen}
                  toggle={this.toggle}
                  handleSubmit={this.updatePayment}
                  details={this.props.details}
                  subscribed={subscribed}
                  email={email}
                  cost={cost}
                  plan={plan}
                  payment_method_added={payment_method_added}
                  createSubscription={this.handleCreateSubscription}
                  createSubscriptionSpinner={
                    this.state.createSubscriptionSpinner
                  }
                  subscription_auto_renew={subscription_auto_renew}
                  disableAutoRenew={this.handleDisableAutoRenew}
                  disableAutoRenewSpinner={this.state.disableAutoRenewSpinner}
                  enableAutoRenew={this.handleEnableAutoRenew}
                  enableAutoRenewSpinner={this.state.enableAutoRenewSpinner}
                />
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    details: state.details.user,
    accounts: state.content.accounts,
  };
}

const mapDispatchToProps = {
  showUserAction,
  showAccountsAction,
  updateBillingPeriodAction,
  updatePaymentAction,
  disableRenewAction,
  enableRenewAction,
};
export default connect(
  mapStateProps,
  mapDispatchToProps,
)(withRouter(CurrentPlan));



// WEBPACK FOOTER //
// ./src/scenes/Profile/CurrentPlan.js